import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'

const _import = require('./_import_' + process.env.NODE_ENV)

import booking from '@/modules/booking/routes'
import special from '@/modules/special/routes'
import settings from '@/modules/settings/routes'
import productsStorage from '@/modules/productsStorage/routes'
import guests from '@/modules/guests/routes'
import services from '@/modules/services/routes'
import reports from '@/modules/reports/routes'
import schedule from '@/modules/schedule/routes'
import orders from '@/modules/orders/routes'

Vue.use(Router)

export const constantRouterMap = [{
    path: '/login',
    component: _import('login/index'),
    hidden: true
  },
  {
    path: '/',
    redirect: '/booking'
  },
  {
    path: '/401',
    component: _import('401')
  }
]

export default new Router({
  routes: constantRouterMap
})

export const asyncRouterMap = [
  ...booking,
  ...guests,
  ...reports,
  ...productsStorage,
  ...special,
  ...services,
  ...schedule,
  ...settings,
  ...orders
]



// WEBPACK FOOTER //
// ./src/router/index.js